(function () {
	'use strict';
	function translate(value) { return typeof window !== 'undefined' && window.folisQuoteConfig && Object.prototype.hasOwnProperty.call(window.folisQuoteConfig.copy || {}, value) ? window.folisQuoteConfig.copy[value] : value; }
	var KEY = 'folis_quote_list_v1';
	function validLine(line) {
		return line && ['code', 'title', 'attributes', 'unit', 'sku', 'selection'].every(function (key) { return typeof line[key] === 'string' && line[key].length <= ({ code: 1000, title: 500, attributes: 4000, unit: 200, sku: 200, selection: 4000 })[key]; }) && line.title.length > 0 && Number.isSafeInteger(line.productId) && line.productId > 0 && Number.isSafeInteger(line.variationId) && line.variationId >= 0 && Number.isInteger(line.quantity) && line.quantity > 0 && line.quantity <= 999999;
	}
	function identity(line) { return JSON.stringify([line.productId, line.variationId, line.selection]); }
	function formatLine(line) { return (line.code || translate('Código não indicado')) + ' — ' + line.title + ' — ' + (line.attributes || translate('Sem atributos indicados')) + ' — ' + translate('Quantidade:') + ' ' + line.quantity + (line.unit ? ' ' + line.unit : ''); }
	function merge(lines, line) {
		var found = lines.find(function (item) { return identity(item) === identity(line); });
		if (found) {
			if (found.quantity + line.quantity > 999999) { throw new Error(translate('A quantidade máxima é 999999.')); }
			found.quantity += line.quantity;
		} else {
			if (lines.length >= 100) { throw new Error(translate('A lista admite até 100 artigos diferentes.')); }
			lines.push(line);
		}
		return lines;
	}
	function snapshotLine(product, variant, choices, quantity) {
		var code = '', attributes = [], unit = '', selection = [];
		product.attributes.forEach(function (attribute) {
			var raw = attribute.variation ? (variant.values[attribute.key] || choices[attribute.key]) : '';
			var values = raw ? attribute.options.filter(function (option) { return option.value === raw; }).map(function (option) { return option.label; }) : attribute.options.map(function (option) { return option.label; });
			if (attribute.variation && !raw) { throw new Error(translate('Escolha todas as opções do artigo.')); }
			if (raw && !values.length) { values = [raw]; }
			var value = values.join(', ');
			if (attribute.variation) { selection.push([attribute.key, raw]); }
			if (attribute.key === 'pa_codigo') { code = value; }
			else if (value) {
				attributes.push(attribute.label + ': ' + value);
				if (['pa_unidade-de-venda', 'unidade-de-venda', 'pa_unidade_venda', 'unidade_venda'].includes(attribute.key)) { unit = value; }
			}
		});
		return { productId: product.id, variationId: variant.id, sku: variant.sku, title: product.title, code: code, attributes: attributes.join('; '), unit: unit, selection: JSON.stringify(selection.sort()), quantity: quantity };
	}
	if (typeof module !== 'undefined' && module.exports) { module.exports = { validLine: validLine, formatLine: formatLine, merge: merge, snapshotLine: snapshotLine }; }
	if (typeof document === 'undefined') { return; }
	var products = Object.create(null);
	var config = window.folisQuoteConfig, lines = [], storageFailed = false, signature = '', requestId = '';
	var dialog = document.getElementById('folis-quote-list');
	if (!config || !dialog) { return; }
	var container = dialog.querySelector('[data-quote-lines]'), company = dialog.querySelector('[data-quote-company]'), notes = dialog.querySelector('[data-quote-notes]'), status = dialog.querySelector('[data-quote-status]'), manual = dialog.querySelector('[data-quote-manual]');
	function read(raw) {
		if (!raw) { return []; }
		var saved = JSON.parse(raw);
		if (saved.version !== 1 || !Array.isArray(saved.lines) || saved.lines.length > 100 || !saved.lines.every(validLine)) { throw new Error('Invalid storage'); }
		return saved.lines;
	}
	try { lines = read(localStorage.getItem(KEY)); } catch (error) { storageFailed = true; }
	function persist() {
		try { localStorage.setItem(KEY, JSON.stringify({ version: 1, lines: lines })); } catch (error) { storageFailed = true; }
		render();
	}
	function element(tag, text, className) {
		var node = document.createElement(tag);
		if (text !== undefined) { node.textContent = text; }
		if (className) { node.className = className; }
		return node;
	}
function render() {
    container.replaceChildren();

    document.querySelectorAll('[data-quote-count]').forEach(function (node) {
        node.textContent = lines.length;
    });

    document.querySelectorAll('[data-quote-header]').forEach(function (node) {
        node.hidden = false;
    });

    dialog.querySelector('[data-quote-storage-warning]').textContent = storageFailed
        ? translate('Não foi possível recuperar ou guardar a lista neste navegador. A lista atual poderá perder-se ao sair.')
        : '';

    dialog.querySelector('[data-quote-review]').hidden = !lines.length;

    manual.hidden = true;
    status.textContent = '';

    if (!lines.length) {
        container.append(
            element(
                'p',
                translate('A sua lista está vazia. Escolha artigos no catálogo.')
            )
        );

        return;
    }

    lines.forEach(function (line, index) {
        var row = element(
            'div',
            undefined,
            'border-0 border-b border-solid border-slate-200 py-3'
        );

        /*
         * Main row:
         * product information on the left,
         * quantity + remove on the right.
         */
        var layout = element(
            'div',
            undefined,
            'flex flex-col gap-2 md:flex-row md:items-center md:justify-between md:gap-6'
        );

        /*
         * Product information
         */
        var info = element(
            'div',
            undefined,
            'min-w-0 flex-1'
        );

        var heading = element(
            'div',
            undefined,
            'flex flex-wrap items-baseline gap-x-3 gap-y-0.5'
        );

        if (line.code) {
            heading.append(
                element(
                    'span',
                    line.code,
                    'text-sm text-slate-500'
                )
            );
        }

        var title = element(
            'span',
            line.title,
            'font-semibold'
        );

        title.id = 'folis-quote-line-' + index;

        heading.append(title);
        info.append(heading);

        if (line.attributes) {
            info.append(
                element(
                    'div',
                    line.attributes.replace(/;\s*/g, ' · '),
                    'mt-0.5 text-sm text-slate-600 break-words'
                )
            );
        }

        /*
         * Controls
         */
        var controls = element(
            'div',
            undefined,
            'flex shrink-0 items-center gap-3 md:justify-end'
        );

        var label = element(
            'label',
            translate('Qtd.'),
            'inline-flex items-center gap-2 text-sm'
        );

        var input = element(
            'input',
            undefined,
            'folis-quote-input w-20'
        );

        input.type = 'number';
        input.min = '1';
        input.max = '999999';
        input.step = '1';
        input.required = true;
        input.value = line.quantity;

        input.setAttribute(
            'aria-label',
            translate('Quantidade de') + ' ' + line.title
        );

        input.setAttribute(
            'aria-describedby',
            title.id
        );

        input.addEventListener('change', function () {
            if (!input.checkValidity()) {
                input.reportValidity();
                input.value = line.quantity;
                return;
            }

            line.quantity = Number(input.value);
            persist();

            var replacement = container.querySelectorAll('input')[index];

            if (replacement) {
                replacement.focus();
            }
        });

        label.append(input);
        controls.append(label);

        var remove = element(
            'button',
            translate('Remover'),
            'folis-quote-secondary text-sm'
        );

        remove.type = 'button';

        remove.setAttribute(
            'aria-label',
            translate('Remover') + ' ' + line.title
        );

        remove.addEventListener('click', function () {
            lines.splice(index, 1);
            persist();

            var next = container.querySelector('button');

            (
                next ||
                dialog.querySelector('[data-folis-modal-close]')
            ).focus();
        });

        controls.append(remove);

        layout.append(info, controls);
        row.append(layout);
        container.append(row);
    });
}
	function setProductMode(modal, adding) {
		var form = modal.querySelector('[data-quote-product]'), details = modal.querySelector('[data-quote-characteristics]'), button = modal.querySelector('[data-quote-configure]');
		if (form) { 
			form.hidden = !adding; 
			form.querySelector('[data-quote-feedback]').textContent = ''; 
			form.querySelector('[data-quote-added]').hidden = true; 
			form.querySelector('[data-quote-body]').hidden = !adding;
		}
		if (button) { button.hidden = adding; }
		if (details) { details.open = !adding; }
		var target = adding && form ? form.querySelector('select,input') : details && details.querySelector('summary');
		if (target) { target.focus(); }
	}
	document.addEventListener('click', function (event) {
		var opener = event.target.closest('[data-quote-mode]'), configure = event.target.closest('[data-quote-configure], [data-choose-more]');
		if (!opener && !configure) { return; }
		var modal = configure ? configure.closest('dialog') : document.getElementById(opener.dataset.folisModalOpen);
		if (modal) { setProductMode(modal, !!configure || opener.dataset.quoteMode === 'add'); }
	});
	// Listing dialogs are fetched on demand and open in "details" mode.
	document.addEventListener('folis:modal-open', function (event) {
		var opener = event.detail.opener;
		if (opener && opener.hasAttribute('data-folis-product-details')) {
			initialize(event.detail.modal);
			setProductMode(event.detail.modal, false);
		}
	});

	function initForm(form) {
		if (form.dataset.quoteReady) { return; }
		form.dataset.quoteReady = 'true';
		var product;
		try {
			var source = document.getElementById('folis-quote-product-' + form.dataset.quoteProduct);
			product = source ? JSON.parse(source.textContent) : products[form.dataset.quoteProduct];
			if (!product) { return; }
			products[form.dataset.quoteProduct] = product;
		} catch (error) { return; }
		var options = form.querySelector('[data-quote-options]'), choice = null, wildcards;
		if (product.variants.length > 1) {
			var label = element('label', translate('Opção'), 'block'); choice = element('select', undefined, 'folis-quote-input block w-full'); choice.required = true;
			var empty = element('option', translate('Escolha uma opção')); empty.value = ''; choice.append(empty);
			product.variants.forEach(function (variant, index) {
				var title = product.attributes.filter(function (a) { return a.variation; }).map(function (a) {
					var raw = variant.values[a.key], option = a.options.find(function (o) { return o.value === raw; });
					return a.label + ': ' + (option ? option.label : raw || translate('Escolher'));
				}).join(' · ');
				var item = element('option', title || translate('Opção') + ' ' + (index + 1)); item.value = index; choice.append(item);
			});
			label.append(choice); options.append(label);
		}
		wildcards = element('div', undefined, 'space-y-4'); options.append(wildcards);
		function selected() { return choice ? (choice.value === '' ? null : product.variants[Number(choice.value)]) : product.variants[0]; }
		function update() {
			wildcards.replaceChildren();
			var variant = selected(); if (!variant) { return; }
			product.attributes.filter(function (a) { return a.variation && !variant.values[a.key]; }).forEach(function (a) {
				var label = element('label', a.label, 'block'), select = element('select', undefined, 'folis-quote-input block w-full'); select.required = true; select.dataset.quoteAttribute = a.key;
				var placeholder = element('option', translate('Escolha uma opção')); placeholder.value = ''; select.append(placeholder);
				a.options.forEach(function (o) { var option = element('option', o.label); option.value = o.value; select.append(option); });
				if (a.options.length === 1) { select.value = a.options[0].value; }
				label.append(select); wildcards.append(label);
			});
		}
		if (choice) { choice.addEventListener('change', update); } update();
		form.addEventListener('input', function () { form.querySelector('[data-quote-feedback]').textContent = ''; form.querySelector('[data-quote-added]').hidden = true; });
		form.addEventListener('submit', function (event) {
			event.preventDefault();
			var feedback = form.querySelector('[data-quote-feedback]');
			try {
				var variant = selected(), choices = {};
				if (!variant) { throw new Error(translate('Escolha uma opção.')); }
				wildcards.querySelectorAll('select').forEach(function (select) { choices[select.dataset.quoteAttribute] = select.value; });
				var line = snapshotLine(product, variant, choices, Number(form.elements.quantity.value));
				if (!validLine(line)) { throw new Error(translate('Verifique as opções e a quantidade do artigo.')); }
				merge(lines, line); persist(); 
				feedback.textContent = translate('Adicionado à lista'); 
				form.querySelector('[data-quote-added]').hidden = false;
				form.querySelector('[data-quote-body]').hidden=true;
			} catch (error) { feedback.textContent = error.message; }
		});
	}
	function initialize(root) {
		if (root.matches && root.matches('[data-quote-product]')) { initForm(root); }
		if (root.querySelectorAll) { root.querySelectorAll('[data-quote-product]').forEach(initForm); }
	}
	initialize(document); render();
	new MutationObserver(function (records) { records.forEach(function (record) { record.addedNodes.forEach(initialize); }); }).observe(document.body, { childList: true, subtree: true });
	window.addEventListener('storage', function (event) { if (event.key === KEY || event.key === null) { try { lines = read(event.newValue); render(); } catch (error) { storageFailed = true; render(); } } });
	function payload() {
		var value = JSON.stringify({ lines: lines, company: company.value, notes: notes.value });
		if (value !== signature) {
			var bytes = new Uint8Array(16); crypto.getRandomValues(bytes); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
			var hex = Array.from(bytes, function (n) { return n.toString(16).padStart(2, '0'); }).join('');
			requestId = [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-'); signature = value;
		}
		return { id: requestId, lines: lines, company: company.value, notes: notes.value };
	}
	function message(data) {
		return translate('Olá! Gostaria de pedir uma cotação.') + '\n' + (data.company ? '\n' + translate('Empresa:') + ' ' + data.company : '') + '\n\n' + data.lines.map(function (line, i) { return (i + 1) + '. ' + formatLine(line); }).join('\n\n') + (data.notes ? '\n\n' + translate('Observações:') + ' ' + data.notes : '') + '\n\n' + translate('Agradeço a validação dos artigos e quantidades indicados.');
	}
	function manualCopy(text) { manual.value = text; manual.hidden = false; manual.focus(); manual.select(); status.textContent = translate('Selecione e copie o pedido para o colar no WhatsApp.'); }
	function record(data) {
		try {
			var body = JSON.stringify(data), blob = new Blob([body], { type: 'application/json' });
			if (blob.size > 60000) { return; }
			try { if (navigator.sendBeacon && navigator.sendBeacon(config.endpoint, blob)) { return; } } catch (error) { /* Try fetch when beacon is unavailable. */ }
			fetch(config.endpoint, { method: 'POST', body: body, headers: { 'Content-Type': 'application/json' }, keepalive: true, credentials: 'omit' }).catch(function () {});
		} catch (error) { /* Best-effort statistics must not interrupt the handoff. */ }
	}
	dialog.querySelector('[data-quote-send]').addEventListener('click', function () {
		if (!lines.length) { return; }
		var data = payload(), text = message(data), url = config.whatsapp + '?text=' + encodeURIComponent(text);
		if (url.length > 8000) { manualCopy(text); status.textContent = translate('O pedido é extenso. Copie o texto abaixo e cole-o na conversa do WhatsApp.'); url = config.whatsapp; }
		record(data); window.open(url, '_blank', 'noopener,noreferrer');
		if (url !== config.whatsapp) { status.textContent = translate('Conclua o envio no WhatsApp. A sua lista foi mantida.'); }
	});
	dialog.querySelector('[data-quote-copy]').addEventListener('click', function () {
		var text = message(payload());
		if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(function () { status.textContent = translate('Pedido copiado.'); }, function () { manualCopy(text); }); } else { manualCopy(text); }
	});
	dialog.querySelector('[data-quote-clear]').addEventListener('click', function () { if (window.confirm(translate('Pretende limpar todos os artigos da lista?'))) { lines = []; persist(); dialog.querySelector('[data-folis-modal-close]').focus(); } });
}());
